export const cognitoConfig = {
  region: 'us-east-2',
  userPoolId: 'us-east-2_D3wdqR2Yp',
  userPoolWebClientId: '2l6d2kn5dfkmdij04n002alfob',
};

export const apiBaseUrl = 'https://beta.makemerry.app/api/account';
